import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 69221 56976"
    {...props}
  >
    <path
      d="M50690 0c-6882 0-12883 4106-16079 10200C31415 4106 25413 0 18531 0 8296 0 0 9075 0 20272c0 18217 34611 36704 34611 36704s34610-18487 34610-36704C69221 9075 60925 0 50690 0z"
      style={{
        fill: "#2b2a29",
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
